import { FC, memo, useMemo } from 'react';
import { useController } from 'react-hook-form';

import Collapse from '@material-ui/core/Collapse';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';

import { HelperTxt } from '../helperTxt/HelperTxt';
import { Radio } from '../radio/Radio';
import { FormRadioButtonGroupProps } from './FormItems.types';

export const FormRadioButtonGroup: FC<FormRadioButtonGroupProps> = memo(
  ({ row = false, variant, groups, radioItem = <Radio />, control, name, required, classes }) => {
    const {
      field,
      fieldState: { error },
    } = useController({
      name,
      control,
    });

    const helperText = useMemo(() => {
      if (error) {
        return error.message;
      }

      if (required) {
        return '*required';
      }

      return '';
    }, [error, required]);

    return (
      <FormControl error={!!error} fullWidth>
        <RadioGroup row={row} {...field}>
          {groups?.map(radioButton => {
            const value = radioButton.id.toString();

            return (
              <>
                <FormControlLabel
                  key={radioButton.id}
                  control={radioItem}
                  label={variant === 'pill' ? null : radioButton.name}
                  value={value}
                  classes={classes}
                />

                {!!radioButton.children && (
                  <Collapse in={field.value === value} unmountOnExit>
                    {radioButton.children}
                  </Collapse>
                )}
              </>
            );
          })}
        </RadioGroup>

        {helperText && <HelperTxt>{helperText}</HelperTxt>}
      </FormControl>
    );
  },
);
